import { HelpTopic } from "../types";

// Commission is the salon's cut: the backend pays the member gross × (1 − commission%)
// (CustomerPurchaseRateBreakdown, MerchantUserSettlementItem).
export const teamMemberAddHelp: HelpTopic = {
  id: "team-member-add",
  title: "راهنمای افزودن عضو تیم",
  intro: "هر کسی که در سالن خدمت می‌دهد را در سه مرحله اضافه کن. مرحله خدمات اختیاری است.",
  steps: [
    {
      key: "1",
      title: "اطلاعات فردی",
      body: (
        <>
          نام، نام خانوادگی، شماره موبایل و جنسیت لازم است؛ عضو تیم با همین شماره وارد پدیکس می‌شود. عکس، عنوان شغلی
          (مثلاً ناخن‌کار)، تاریخ تولد و رنگ تقویم اختیاری‌اند؛ رنگ تقویم، نوبت‌های این فرد را در تقویم از بقیه جدا می‌کند.
        </>
      ),
      image: "/help/team-add-1.png",
      imageAlt: "نمونه پرشده‌ی مرحله اطلاعات فردی: نام، نام خانوادگی، عنوان شغلی، شماره تلفن و جنسیت",
    },
    {
      key: "2",
      title: "خدمات",
      optional: true,
      body: (
        <>
          خدماتی که این فرد انجام می‌دهد را تیک بزن تا موقع ثبت نوبت برای او نمایش داده شوند. اگر هنوز مشخص نیست، رد
          شو؛ بعداً هم از فهرست تیم با «ویرایش خدمات» اضافه می‌شود.
        </>
      ),
      image: "/help/team-add-2.png",
      imageAlt: "مرحله خدمات با دو خدمت تیک‌خورده: کوتاهی مو و رنگ و مش",
    },
    {
      key: "3",
      title: "تنظیمات: دسترسی و کمیسیون",
      body: (
        <>
          <b>کاربر عادی</b> فقط تقویم، مشتریان، ثبت فاکتور، فاکتورها، نوبت‌های آنلاین و بازاریابی را می‌بیند؛{" "}
          <b>دسترسی کامل</b> همه بخش‌ها را. <b>کمیسیون</b> یعنی چند درصد از مبلغ هر خدمت سهم سالن است و بقیه به این فرد
          می‌رسد؛ ۰ یعنی کل مبلغ برای خود اوست.
        </>
      ),
      image: "/help/team-add-3.png",
      imageAlt: "مرحله تنظیمات: سطح دسترسی، کمیسیون ۴۰ درصد و نمایش در وبسایت",
    },
  ],
  tip: <>بعد از افزودن، شیفت کاری‌اش را در «شیفت کاری» تنظیم کن تا در تقویم برایش زمان آزاد نمایش داده شود.</>,
};
